<template>
  <div class="wrapper">
    <LogoMark class="loading-panel__logo" width="40px" height="54px" />
    <p>Loading&hellip;</p>
  </div>
</template>

<script>
import LogoMark from "@/assets/svg/logo-mark.svg";

export default {
  name: "LoadingAnimation",
  components: {
    LogoMark,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: $white;
  transition: all 0.3s ease;
}

.loading-panel__logo {
  path {
    opacity: 0;
  }

  .logo-mark__layer-1 {
    animation: FADE-IN-1 3s infinite;
  }
  .logo-mark__layer-2 {
    animation: FADE-IN-2 3s infinite;
  }
  .logo-mark__layer-3 {
    animation: FADE-IN-3 3s infinite;
  }
  .logo-mark__layer-4 {
    animation: FADE-IN-4 3s infinite;
  }
  .logo-mark__layer-5 {
    animation: FADE-IN-5 3s infinite;
  }
}

.loading-panel-enter,
.loading-panel-leave-active {
  opacity: 0;
  transform: scale(0.9);
}

@keyframes FADE-IN-1 {
  20% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
}
@keyframes FADE-IN-2 {
  35% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
}
@keyframes FADE-IN-3 {
  50% {
    opacity: 0;
  }
  55% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
}
@keyframes FADE-IN-4 {
  65% {
    opacity: 0;
  }
  70% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
}
@keyframes FADE-IN-5 {
  80% {
    opacity: 0;
  }
  85% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
}
</style>
